import { render, staticRenderFns } from "./UpcomingTeamEvents.vue?vue&type=template&id=31c86d37"
import script from "./UpcomingTeamEvents.vue?vue&type=script&lang=js"
export * from "./UpcomingTeamEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports